import React, { FC, useEffect, useMemo } from 'react';
import _find from 'lodash/find';
import _map from 'lodash/map';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts } from '@minecraft.drawer';
import { useProfileStatusOptions } from '@blocs.filter';
import { FiltersNameEnum } from '../../../shared/types';
import { FormItem } from '../../../shared/styles';
import { FilterDrawerType, FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';
import { ProfileStatus } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const ProfileStatusCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);
  const primaryProfileStatusOptions = useProfileStatusOptions();

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.profileStatus
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const profileStatusOptions = useMemo(() => {
    return _map(primaryProfileStatusOptions, (option) => ({
      ...option,
      count: _find(filtersCounts?.[FiltersCountNameEnum.profileStatusToSearch], { key: option.value })?.docCount || 0,
    }));
  }, [filtersCounts]);

  useEffect(() => {
    assignOptionsToCategoryFilters({
      [FiltersNameEnum.profileStatus]: profileStatusOptions,
    });
  }, [profileStatusOptions]);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <ProfileStatus
          name={FiltersNameEnum.profileStatus}
          label={filtersLabelOfAudience[FiltersNameEnum.profileStatus]}
        />
      </FormItem>
    )
  );
};

export default ProfileStatusCategory;
